import { useAtomValue } from "jotai";
import { useResolvingNowQuery } from "web_myplann/Api/NotificationCenter/useResolvingNowQuery";
import { useUpcomingTimelineQuery } from "web_myplann/Api/NotificationCenter/useUpcomingTimelineQuery";
import { useDocumentsFeatureOptional } from "web_myplann/Api/Rights/RightsProvider";
import { timelineFilterAtom } from "web_myplann/NotificationCenter/Atoms/timelineFilterAtom";
import { useGroupUpcomingItems } from "web_myplann/NotificationCenter/Hooks/useGroupUpcomingItems";
import { isDocumentsOnlyActive } from "web_myplann/NotificationCenter/Utils/isDocumentsOnlyActive";

export const useUpcomingTimelineGroups = (options?: { enabled?: boolean }) => {
	const { horizon, upcomingType, upcomingDocumentsOnly } =
		useAtomValue(timelineFilterAtom);
	const hasDocumentsFeature = useDocumentsFeatureOptional();
	const documentsOnly = isDocumentsOnlyActive(
		upcomingDocumentsOnly,
		hasDocumentsFeature,
	);
	const upcomingQuery = useUpcomingTimelineQuery(
		{ horizon, type: upcomingType, documentsOnly },
		options,
	);
	const resolvingNowQuery = useResolvingNowQuery(
		{ type: upcomingType, documentsOnly },
		options,
	);
	const timeGroups = useGroupUpcomingItems(
		upcomingQuery.data?.items ?? [],
		horizon,
	);

	return {
		upcomingQuery,
		resolvingNowQuery,
		resolvingNow: resolvingNowQuery.data?.items ?? [],
		timeGroups,
	};
};
